<script lang="ts">
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { ResponsiveVars } from '@twist/core';

  const responsiveVars = new ResponsiveVars()
    .addFluid('padding-top', toFluidVarInput(12, 18))
    .toCSS();
</script>

<span class={responsiveVars}>
  <slot />
</span>

<style>
  span {
    display: block;
    padding-top: var(--padding-top);
    border-top: 1px solid black;
  }
</style>
